var map = {
	"./HAPAG.png": 1897,
	"./HMM.png": 6069,
	"./Interasia.png": 1123,
	"./ck_maritime.png": 9661,
	"./cnc.png": 60,
	"./cosco.png": 2266,
	"./evergreen.png": 859,
	"./faq_image.png": 710,
	"./form_title_image1.png": 6531,
	"./form_title_image_text.png": 1458,
	"./guide_image01.png": 7845,
	"./guide_image02.png": 6477,
	"./guide_image03.png": 7698,
	"./heung_a_line.png": 2664,
	"./i_line.png": 839,
	"./kambarakisen.png": 4299,
	"./kmtc.png": 6349,
	"./message.png": 1037,
	"./numsung.png": 3488,
	"./one.png": 215,
	"./oocl.png": 3222,
	"./sealead.png": 4755,
	"./sinokor.png": 8654,
	"./sinotrans.png": 2209,
	"./truxing.png": 6704,
	"./wan_hai_lines.png": 6347
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2951;